import './switch-input.scss';


export default (props) => {
    return (
        <label htmlFor={props.id || props.name} className={`input input-switch ${props.className}`} style={props.style}>
  <span className="group">
    <input id={props.id || props.name} name="input_switch" type="checkbox" role="switch" checked={props.value} onChange={props.onChange}/>
    <span className="svg-switch">
      <svg className="svg" width="34px" height="20px" viewBox="0 0 38 24">
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
          <rect className="fill" x="2" y="2" width="34" height="20" rx="10"></rect>
          <circle className="stroke" cx="12" cy="12" r="7"></circle>
        </g>
      </svg>
    </span>
    <span className="label-inline">{props.label}</span>
  </span>
</label>
    )
};